
interface MobileAuthModeToggleProps {
  mode: "signin" | "signup";
  onToggleMode: () => void;
}

export function MobileAuthModeToggle({ mode, onToggleMode }: MobileAuthModeToggleProps) {
  return (
    <div className="flex rounded-lg bg-muted p-1">
      <button
        type="button"
        onClick={onToggleMode}
        className={`flex-1 py-2 px-4 text-sm font-medium rounded-md transition-colors ${
          mode === "signin"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={onToggleMode}
        className={`flex-1 py-2 px-4 text-sm font-medium rounded-md transition-colors ${
          mode === "signup"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        Sign Up
      </button>
    </div>
  );
}
